import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './Home.css'

import { setupSocket } from './../actions/socket'

import Waiting from './../components/Waiting'
import Scoreboard from './../components/scoreboard/Scoreboard'
import PreMatch from './../components/scoreboard/PreMatch'

class Home extends Component {
  componentDidMount() {
    this.props.setupSocket(
      this.props.match.params.port,
    )
  }

  getParams() {
    const s = this.props.location.search,
      split = s.split('&')
    let m = {}
    split.forEach(spl => {
      const sub = spl
        .toLowerCase()
        .replace('?', '')
        .split('=')
      m[sub[0]] = sub[1]
    })
    return m
  }

  render() {
    const params = this.getParams()
    console.log('Params', params)
    if (this.props.running) {
      return <Scoreboard />
    }
    if (this.props.set && this.props.league) {
      return <PreMatch />
    }
    return (
      <Waiting
        port={this.props.match.params.port}
        bg={params.bg}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  running: state.match.running,
  set: state.match.set,
  league:
    state.match.match_id &&
    state.match.match_id.indexOf('manual') === -1 &&
    state.match.match_id.indexOf('::') === -1,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setupSocket: port =>
    dispatch(setupSocket(port)),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Home)
)
